<div class="card-list">
  @for (pet of showPets; track pet; let i = $index) {
    <div class="pet-card-with-wide-border" [class.selected]="isCardSelected(i)">
      <div class="pet-card" [class.small]="!showButton" (click)="selectCard(i)">
        <div class="pet-card-flipper" [class.flipped]="isCardFlipped(i)">
          <div class="pet-card-front">
            <cpf-pet-card [petInfo]="pet" [showSubmitButton]="showButton" (actionButtonClickEmitter)="onCardActionButtonClick.emit()"></cpf-pet-card>
          </div>
          <div class="pet-card-back">
            <cpf-insurance-card [pet]="pet"></cpf-insurance-card>
          </div>
        </div>
        @if (showFlippedCards) {
          <div class="flip-button-container" (click)="cardClicked(i)">
            <mat-icon svgIcon="circle-left"></mat-icon>
          </div>
        }
      </div>
    </div>
  }

  @if (showBuyInsuranceCard) {
    <div class="pet-card bg-white last">
      @if (!isShowAllPets) {
        <button class="button primary" (click)="showAllPets()">{{'pet-carousel.show-all-contracts'| translate}}</button>
      }
      @if (isShowAllPets) {
        <button class="button primary" (click)="hideExpiredPets()">{{'pet-carousel.show-only-active'| translate}}</button>
      }
      <button class="button primary" (click)="openClosingPage()">{{'pet-carousel.buy-insurance-button'| translate}}</button>
    </div>
  }
</div>
